module.exports = __webpack_public_path__ + "img/rules_13.05c9e8ae.png";